import { Card, Checkbox, Drawer, Empty, Input, Select, Tag, notification } from "antd";
import { get } from "lodash";
import { useMutation } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";

const DAYS = [
  { value: "mon", label: "Lun" },
  { value: "tue", label: "Mar" },
  { value: "wed", label: "Mer" },
  { value: "thu", label: "Jeu" },
  { value: "fri", label: "Ven" },
  { value: "sat", label: "Sam" },
  { value: "sun", label: "Dim" },
];

const ScheduleDetail = ({ schedule, open, onClose, onRefetch }) => {
  const [updateSchedule] = useMutation(graphql.mutations.UPDATE_CRM_SENDING_SCHEDULE);

  if (!schedule) return null;

  const saveField = async (field, value) => {
    try {
      await updateSchedule({
        variables: { where: { id: schedule.id }, data: { [field]: value } },
      });
      if (onRefetch) onRefetch();
    } catch (err) {
      notification.error({ message: "Échec de la mise à jour" });
    }
  };

  return (
    <Drawer
      title={schedule.name}
      open={open}
      onClose={onClose}
      width={420}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <div>
          <label style={{ fontSize: 12, color: "#6b7280", display: "block", marginBottom: 4 }}>Nom</label>
          <Input defaultValue={schedule.name} onBlur={(e) => saveField("name", e.target.value)} />
        </div>

        <div>
          <label style={{ fontSize: 12, color: "#6b7280", display: "block", marginBottom: 4 }}>Fuseau horaire</label>
          <Select defaultValue={schedule.timezone} style={{ width: "100%" }} onChange={(val) => saveField("timezone", val)} showSearch>
            <Select.Option value="Europe/Paris">Europe/Paris</Select.Option>
            <Select.Option value="America/New_York">America/New_York</Select.Option>
            <Select.Option value="America/Los_Angeles">America/Los_Angeles</Select.Option>
            <Select.Option value="UTC">UTC</Select.Option>
            <Select.Option value="Asia/Tokyo">Asia/Tokyo</Select.Option>
            <Select.Option value="Europe/London">Europe/London</Select.Option>
            <Select.Option value="Europe/Berlin">Europe/Berlin</Select.Option>
          </Select>
        </div>

        <div>
          <label style={{ fontSize: 12, color: "#6b7280", display: "block", marginBottom: 8 }}>Jours d'envoi</label>
          <Checkbox.Group
            value={schedule.days || []}
            onChange={(days) => saveField("days", days)}
            options={DAYS.map((d) => ({ value: d.value, label: d.label }))}
          />
        </div>

        <div className="d-flex" style={{ gap: "16px" }}>
          <div style={{ flex: 1 }}>
            <label style={{ fontSize: 12, color: "#6b7280", display: "block", marginBottom: 4 }}>Début</label>
            <Input defaultValue={schedule.startHour} onBlur={(e) => saveField("startHour", e.target.value)} placeholder="09:00" />
          </div>
          <div style={{ flex: 1 }}>
            <label style={{ fontSize: 12, color: "#6b7280", display: "block", marginBottom: 4 }}>Fin</label>
            <Input defaultValue={schedule.endHour} onBlur={(e) => saveField("endHour", e.target.value)} placeholder="18:00" />
          </div>
        </div>

        <Card size="small" style={{ background: "#f5f7fa" }}>
          <div style={{ fontSize: 13, color: "#1e293b" }}>
            Envois {(schedule.days || []).join(", ")}, {schedule.startHour}–{schedule.endHour} {schedule.timezone}
          </div>
        </Card>

        <div>
          <label style={{ fontSize: 12, color: "#6b7280", display: "block", marginBottom: 4 }}>Campagnes assignées</label>
          {(schedule.assignedCampaignIds || []).length === 0
            ? <span style={{ color: "#9ca3af", fontSize: 13 }}>Aucune</span>
            : <div>{(schedule.assignedCampaignIds || []).map((cid) => <Tag key={cid}>{cid}</Tag>)}</div>
          }
        </div>
      </div>
    </Drawer>
  );
};

export default ScheduleDetail;
